import(/* webpackMode: "eager" */ "/stage-regression/app/globals.css");
import(/* webpackMode: "eager" */ "/stage-regression/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/stage-regression/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/stage-regression/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/stage-regression/components/ui/tooltip.tsx")